const modulesFiles = require.context('', true, /.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^.\/(.*)\.js/, '$1')
  const value = modulesFiles(modulePath)
  if (moduleName !== 'api') {
    modules[moduleName] = value
  }
  return modules
}, {})
console.log(modules, 'modules');
export default modules



// WEBPACK FOOTER //
// ./src/api/api.js